import { useCallback } from 'react';

import { useNotification } from '@/hooks';
import { NotificationSeverity } from '@/components/notifications/Notification';
import { useDeleteCommerceSettingsMutation } from '../services/commerce-settings.service';

interface UseDeleteCommerceSettingsProps {
  onSuccess?: () => void;
}

const useDeleteCommerceSettings = ({
  onSuccess,
}: UseDeleteCommerceSettingsProps = {}) => {
  const { showNotification } = useNotification();

  const [deleteCommerceSettings, { isLoading: isDeletingCommerceSettings }] =
    useDeleteCommerceSettingsMutation();

  const handleDeleteCommerceSettings = useCallback(
    async (commerceSettingsId: string): Promise<void> => {
      try {
        await deleteCommerceSettings(commerceSettingsId).unwrap();
        showNotification(
          'Configuración eliminada correctamente',
          NotificationSeverity.success
        );

        if (onSuccess) {
          onSuccess();
        }
      } catch (error: any) {
        const status = error?.status || error?.data?.status;
        const message = error?.data?.message || error?.message;

        let errorMessage = 'Error al eliminar la configuración';

        if (status === 404) {
          errorMessage = 'Configuración no encontrada';
        } else if (status === 409) {
          errorMessage =
            'No se puede eliminar la configuración porque está siendo utilizada';
        } else if (message) {
          errorMessage = message;
        }

        showNotification(errorMessage, NotificationSeverity.error);
      }
    },
    [deleteCommerceSettings, showNotification, onSuccess]
  );

  return {
    handleDeleteCommerceSettings,
    isLoading: isDeletingCommerceSettings,
  };
};

export default useDeleteCommerceSettings;
